import React from 'react'
import CalculatorLabelAndTextDisplay from 'components/CalculatorLabelAndTextDisplay'
import injectSheet from 'react-jss'
import style from './style'

const ModelResolutionDisplay = ({ resolutionName, resolutions, classes }) => {
  const className = resolutions.every(r => r.text.toLowerCase() !== resolutionName.toLowerCase()) ? classes.smallResolutionLabel : ''
  return (
    <CalculatorLabelAndTextDisplay labelText='Resolution'>
      { resolutionName.match('12MP 270°')
        ? <div>12 MP</div>
        : <div className={className}>{resolutionName}</div>
      }
    </CalculatorLabelAndTextDisplay>
  )
}

export default injectSheet(style)(ModelResolutionDisplay)



// WEBPACK FOOTER //
// ./src/components/ResolutionContainer/ModelResolutionDisplay/index.js